import React from 'react'

export default function Footer(){
    
    return (
        <section className="main-content">
            <footer className="footer">
                <span>Copyright © 2020 FixedPlus</span>
            </footer>
        </section>
    )
}

